/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import ReactTags from "react-tag-autocomplete";

class Tags extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: "",
			hasFocus: false,
		};
	}

	buildTagObjects = ids => {
		let tags = [];
		if (!Array.isArray(ids)) {
			ids = [ids];
		}
		ids.forEach(id => {
			let name = id;
			if (this.props.dataObjects) {
				let object = this.props.dataObjects.find(object => object.id === id);
				if (this.props.dataObjectKey) {
					object = this.props.dataObjects.find(object => object[this.props.dataObjectKey] === id);
				}
				if (this.props.dataObjectLabel && object) {
					name = object[this.props.dataObjectLabel];
				}
			}
			tags.push({ id: id, name: name });
		});
		return tags;
	};

	buildOptionObjects = () => {
		let tags = [];
		if (this.props.dataObjects) {
			this.props.dataObjects.forEach(object => {
				let name = object.id;
				let key = object.id;
				if (this.props.dataObjectKey) {
					key = object[this.props.dataObjectKey];
				}
				if (this.props.dataObjectLabel) {
					name = object[this.props.dataObjectLabel];
				}
				tags.push({ id: key, name: name });
			});
		}
		return tags;
	};

	addTag = tag => {
		const { addTag, isSimpleInput } = this.props;
		let newValue = this.props.fieldState.value ? this.props.fieldState.value.concat() : [];
		let addedTagValue = "";
		if (tag.id) {
			addedTagValue = tag.id;
		} else {
			addedTagValue = tag.name;
		}
		newValue.push(addedTagValue);
		if (!isSimpleInput) {
			this.props.fieldApi.setValue(newValue);
			this.props.fieldApi.setTouched(true);
		}
		if (addTag) {
			addTag(tag);
		}
	};

	handleAddition = tag => {
		let valid = true;
		if (this.props.max && this.props.fieldState.value && this.props.fieldState.value.length === this.props.max) {
			valid = `Reached Max of ${this.props.max}`;
		} else if (this.props.handleAddition && !tag.id) {
			valid = false;
			this.props.handleAddition(tag, this.props.fieldState.value).then(data => {
				if (data.result === true) {
					this.addTag(data.tag);
					return true;
				} else {
					this.props.fieldApi.setError(data);
					return data;
				}
			});
		}

		if (valid === true) {
			this.addTag(tag);
		} else {
			this.props.fieldApi.setError(valid);
		}
	};

	handleDelete = index => {
		const { removeTag, isSimpleInput } = this.props;

		let newValue = this.props.fieldState.value ? this.props.fieldState.value.concat() : [];
		newValue.splice(index, 1);

		if (!isSimpleInput) {
			this.props.fieldApi.setValue(newValue);
			this.props.fieldApi.setTouched(true);
		}
		if (removeTag) {
			removeTag(index);
		}
	};

	handleFocus = () => {
		this.setState({ hasFocus: true });
	};

	handleBlur = () => {
		this.setState({ hasFocus: false });
	};

	handleInputChange = () => {
		let { error } = this.props.fieldState;
		if (error) {
			this.props.fieldApi.setError("");
		}
	};

	render() {
		let tags = [];
		const { placeholder, tagInstructions, helperText, isRequired, simpleValue } = this.props;
		const { value, error } = this.props.fieldState;
		if (simpleValue) {
			tags = this.buildTagObjects(simpleValue);
		} else if (value) {
			tags = this.buildTagObjects(value);
		}
		let suggestions = this.buildOptionObjects();
		const shouldFocus = tags.length > 0 || this.state.hasFocus;
		const isFocused = shouldFocus ? " focus" : "";
		const hasError = error ? " has-error" : "";
		let placehold = " ";
		if (this.state.hasFocus) {
			placehold = tagInstructions;
		}
		let label = placeholder;
		if (this.props.allowNew) {
			label = `${placeholder} (Enter or Tab to Add Item)`;
		}

		return (
			<div className="tags-input">
				<div className={`input-wrap${isFocused}${hasError}`}>
					<div className="input-box-wrap">
						<div className="placeholder">
							<span className={shouldFocus ? "caption-text" : ""}>
								{isRequired && <span className="isrequired-label">*</span>}
								{label}
							</span>
						</div>
						<div className="input-box tag-shim">
							<ReactTags
								autofocus={false}
								tags={tags}
								placeholder={placehold}
								suggestions={suggestions}
								handleDelete={this.handleDelete.bind(this)}
								handleAddition={this.handleAddition.bind(this)}
								allowNew={this.props.allowNew}
								handleFocus={this.handleFocus}
								handleBlur={this.handleBlur}
								minQueryLength={this.props.minQueryLength ? this.props.minQueryLength : 2}
								handleInputChange={this.handleInputChange}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<div className="caption-text helper-message">{helperText}</div>
						</div>
						<div className="col-xs-6">
							<div className="error-message caption-text">{error ? error : ""}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Tags.propTypes = {
	addTag: PropTypes.func,
	allowNew: PropTypes.bool,
	dataObjectKey: PropTypes.string,
	dataObjectLabel: PropTypes.string,
	dataObjects: PropTypes.array,
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	handleAddition: PropTypes.func,
	helperText: PropTypes.string,
	isRequired: PropTypes.bool,
	isSimpleInput: PropTypes.bool,
	max: PropTypes.number,
	minQueryLength: PropTypes.number,
	placeholder: PropTypes.string,
	removeTag: PropTypes.func,
	simpleValue: PropTypes.array,
	tagInstructions: PropTypes.string,
};

const Wrapper = asField(({ fieldState, ...props }) => <Tags fieldState={fieldState} {...props} />);

export default Wrapper;
